export const APP_VERSION = 'v2026.09.10.0';
